import React from 'react';
import $ from "jquery";
import { Button } from 'semantic-ui-react';

import Title from '../../title';
import Loading from '../../loadings';
import Server from '../../../functions/server';
import Permission from '../../../functions/permission';
import View from './detailstatement';

class PurchaserStatement extends React.Component {

  state = {
    fromDate: this.getFormatedDate(new Date(), 7),
    toDate: this.getFormatedDate(new Date()), menuPermission: [],
    purchaserStatement: [], openingBalance: 0, closingBalance: 0
  }

  componentDidMount() {
    this.menuControl();
  }

  menuControl() {
    let menuPermission = Permission('purchaser-statement', this.props.menus);
    if (menuPermission.view) {
      this.getPurchaserStatement();
    }
    this.setState({ menuPermission })
  }

  // Set From And To Date Function
  getFormatedDate(dates, interval) {
    if (interval > 0) {
      dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
    }
    let month = dates.getMonth() + 1; let date = dates.getDate();
    month = (month > 10) ? month : "0" + month;
    date = (date > 10) ? date : "0" + date;
    let x = dates.getFullYear() + "-" + month + "-" + date;
    if (interval == 7) {
      x = dates.getFullYear() + "-" + month + "-01";
    }
    return x;
  }

  // Data And Test Box Handle Function
  handleChange = name => event => { this.setState({ [name]: event.target.value }); };

  // Get Purchaser Statement function
  getPurchaserStatement() {
    let context = this;
    $.ajax({
      type: 'POST', data: { 'fromdate': context.state.fromDate, 'todate': context.state.toDate },
      url: Server() + 'purchaserStatement/getStatement.php',
      success: function(purchaserStatement) {
        let openingBalance = 0;
        let closingBalance = 0;
        try {
          purchaserStatement = JSON.parse(purchaserStatement);
          purchaserStatement.map((c) => {
            purchaserStatement = c.data;
            openingBalance = c.opening_balance;
            closingBalance = c.closing_balance;
          })
          context.setState({ purchaserStatement, load: false, openingBalance, closingBalance })
        } catch (error) {
          context.setState({ load: false })
        }
      },
      error: function(err) {
        alert('Try again!!!')
      }
    });
  }

  // Make Decimal Point
  makeDecimalPoint = (value) => {
    try {
      value = value.toFixed(2);
    } catch (value) {
      value = 0;
    }
    return value;
  }

  // Convert Into Number
  ConvertIntoNumber = (value) => {
    try {
      value = Number(value);
    } catch (error) {
      value = 0;
    }
    return value;
  }

  render() {
    let i = 1;
    return (
      <div>
        <Title title='Purchaser Statement' openDrawer={this.props.openDrawer}/>
        { this.state.menuPermission.view ? 
          (
            <div style={{padding: '10px'}}>
                <div style={{display: 'flex'}}>
                  <div style={{marginLeft: 5}}>
                      <b>From Date</b><br/>
                      <input type="date"  id="date" value={this.state.fromDate}
                          style={{height: 35 }} onChange={this.handleChange('fromDate')} />
                  </div>
                  <div style={{marginLeft: 5}}>
                      <b>To Date</b><br/>
                      <input type="date" id="date" value={this.state.toDate}
                          style={{height: 35 }} onChange={this.handleChange('toDate')} />
                  </div>
                  <br/>
                  <Button primary onClick={this.getPurchaserStatement.bind(this)} style={{height: '36px', marginTop: '1.4%'}}>Submit</Button>
                </div>
                <div style={{display: 'flex'}}>
                  <div style={{width: '50%', textAlign: 'left', fontSize: '18px', color: 'blue'}}>
                    {'Opening Balance : '+this.makeDecimalPoint(this.ConvertIntoNumber(this.state.openingBalance))}
                  </div>
                  <div style={{width: '50%', textAlign: 'right', fontSize: '18px', color: 'blue'}}>
                    {'Closing Balance : '+this.makeDecimalPoint(this.ConvertIntoNumber(this.state.closingBalance))}
                  </div>
                </div>
                <table id="table" width="100%" style={{marginTop: '2px'}}>
                  <tr>
                    <th id="tableheader"><center>Sino</center></th>
                    <th id="tableheader"><center>Purchaser Name</center></th>
                    <th id="tableheader"><center>Opening Balance</center></th>
                    <th id="tableheader"><center>Closing Balance</center></th>
                    <th id="tableheader"><center>View</center></th>
                  </tr>
                  
                  { this.state.purchaserStatement.map((c) => {
                      let openingBalance = this.ConvertIntoNumber(c.openingbalance);
                      let closingBalance = this.ConvertIntoNumber(c.closingbalance);
                      
                      return (
                        <tr>
                          <td><center>{i++}</center></td>
                          <td>{c.name}</td>
                          <td><div style={{textAlign: 'right'}}>{this.makeDecimalPoint(openingBalance)}</div></td>
                          <td><div style={{textAlign: 'right'}}>{this.makeDecimalPoint(closingBalance)}</div></td>
                          <td>
                            <center style={{color: 'blue', cursor: 'pointer'}}>
                              <View id={c.id} toDate={this.state.toDate} fromDate={this.state.fromDate}  closingBalance={closingBalance} openingBalance={openingBalance} />
                            </center>
                          </td>
                        </tr>
                      )
                    })
                  }

                </table>
            </div>
          ):
          (
            <center>
              You Are Not Allow To Access This Menu!!!
            </center>
          )
        }
      </div>
    );
  }
}

export default PurchaserStatement;
